import { RootState } from "store/store"
import { EstadoRequisicao } from "store/types";


class NovoComentarioSelector {
  static readonly isCarregando = (it: RootState) => it.comentariosSolicitacao.novoComentario.estado === EstadoRequisicao.CARREGANDO;
  static readonly erros = (it: RootState) => it.comentariosSolicitacao.novoComentario.erros;
  static readonly hasErros = (it: RootState) => it.comentariosSolicitacao.novoComentario.erros !== undefined;

  static readonly isEmEdicao = (it: RootState) => it.comentariosSolicitacao.novoComentario.emEdicao;
}


class ListaComentariosSelector {
  static readonly elementos = (it: RootState) => it.comentariosSolicitacao.comentarios.elementos;
  static readonly isFinalDaLista = (it: RootState) => it.comentariosSolicitacao.comentarios.pagina.atual >= it.comentariosSolicitacao.comentarios.pagina.total;

  static readonly erros = (it: RootState) => it.comentariosSolicitacao.comentarios.erros;
  static readonly estado = (it: RootState) => it.comentariosSolicitacao.comentarios.estado;
}

export class ComentariosSolicitacaoSelector {
  static readonly novo = NovoComentarioSelector;
  static readonly lista = ListaComentariosSelector;
}
